var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_355_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 12.8893C9.33337 11.9461 9.70802 11.0417 10.3749 10.3748C11.0418 9.7079 11.9463 9.33325 12.8894 9.33325H24.444C24.911 9.33325 25.3734 9.42523 25.8049 9.60394C26.2363 9.78264 26.6283 10.0446 26.9585 10.3748C27.2887 10.705 27.5507 11.097 27.7294 11.5284C27.9081 11.9599 28 12.4223 28 12.8893V24.4439C28 24.9109 27.9081 25.3733 27.7294 25.8047C27.5507 26.2362 27.2887 26.6282 26.9585 26.9584C26.6283 27.2886 26.2363 27.5505 25.8049 27.7292C25.3734 27.9079 24.911 27.9999 24.444 27.9999H12.8894C12.4224 27.9999 11.96 27.9079 11.5286 27.7292C11.0971 27.5505 10.7051 27.2886 10.3749 26.9584C10.0447 26.6282 9.78276 26.2362 9.60406 25.8047C9.42535 25.3733 9.33337 24.9109 9.33337 24.4439V12.8893Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34933 22.316C4.94046 22.0829 4.60036 21.746 4.36343 21.3393C4.1265 20.9327 4.00113 20.4707 4 20V6.66667C4 5.2 5.2 4 6.66667 4H20C21 4 21.544 4.51333 22 5.33333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.8423725ee353d2c1d71738218635a22e.svg";
export { ForwardRef as ReactComponent };